import { list as getList } from "~/api/contractCron";
import * as types from "../mutation-types";
import store from "~/store";
import { entityStoreStatus } from '~/mixins/entityStoreStatus';
import { clearableStore } from "~/mixins/clearableStore";

export const state = {
  isLoading: false,
  list: null,
  isInitialLoadPending: true
};

export const mutations = {
  ...clearableStore.mutations,
  [types.SET_IS_LOADING_CONTRACT_CRONS](state, status) {
    state.isLoading = status;
  },
  [types.SET_CONTRACT_CRONS](state, data) {
    state.list = data.data;
    state.isInitialLoadPending = false;
  }
};

/**
 * Actions
 */
export const actions = {
  fetchContractCrons({ commit }, contractId = null) {
    commit(types.SET_IS_LOADING_CONTRACT_CRONS, true);

    let activeContractId = contractId || store.getters["contract/activeContract"]?.id;

    if (activeContractId) {
      getList(activeContractId).then((response) => {
        let { data } = response;
        commit(types.SET_CONTRACT_CRONS, data);
        commit(types.SET_IS_LOADING_CONTRACT_CRONS, false);
      }).catch((error) => {
        commit(types.SET_IS_LOADING_CONTRACT_CRONS, false);
      });
    } else {
      commit(types.SET_IS_LOADING_CONTRACT_CRONS, false);
    }
  }
};

/**
 * Getters
 */
export const getters = {
  list: (state) => state.list,
  isLoading: (state) => state.isLoading,
  isInitialLoadPending: (state) => state.isInitialLoadPending,
  ...entityStoreStatus.getters
};
